import AvatarIcon from '../../../assets/medium_default_optimized.png';

const MenuDropdown = ({ setOpen, listItem, profile }) => {
  return (
    <div>
      {/* User Info Section */}
      {profile && (
        <div className="px-[10px] py-[12px] border-b border-gray-100 mb-2">
          <div className="flex items-center gap-3">
            <img
              src={profile?.imgUrl || AvatarIcon}
              alt="Profile"
              className="w-10 h-10 rounded-full border border-gray-200 object-cover"
            />
            <div className="flex-1 min-w-0">
              <p className="font-bold text-sm text-gray-900 truncate">
                {profile?.firstName && profile?.lastName
                  ? `${profile.firstName} ${profile.lastName}`
                  : profile?.username || 'User'}
              </p>
              <p className="text-xs text-gray-500 truncate">@{profile?.username}</p>
            </div>
          </div>
        </div>
      )}

      {/* Menu Items */}
      {listItem?.map((item, index) => (
        <div
          onClick={() => {
            item.onClick();
            setOpen(false);
          }}
          key={index}
          className={`${item.isHidden ? 'hidden' : ''} hover:bg-04-anti-flash-white hover:rounded-[8px] cursor-pointer flex items-center gap-[12px] px-[10px] py-[8px]`}
        >
          {typeof item.icon === 'string' ? <img src={item.icon} alt={item.icon} /> : <item.icon />}
          <p className="font-extrabold text-sm">{item.name}</p>
        </div>
      ))}
    </div>
  );
};

export default MenuDropdown;
